import View from "ol/View";
import {OSM,  Vector, Vector as VectorSource} from 'ol/source';
import { fromLonLat } from "ol/proj";
import Style from "ol/style/Style";
import Fill from "ol/style/Fill";
import GeoJSON from 'ol/format/GeoJSON.js';
import VectorLayer from "ol/layer/Vector";
import Stroke from "ol/style/Stroke";
import { Geometry } from "ol/geom";
import TileLayer from "ol/layer/Tile";
import { Map ,Feature} from "ol";
import  { weatherLayerGroup } from "../mainLayer/weather/weatherLayer";
import { latCoordinate, longCoordinate } from "../initial/quickSlider/RoundMenu";
import Text from 'ol/style/Text'; 
import { pressureLayerGroup } from "./weather/pressure/pressureLayer";


var osmLayer = new TileLayer({
  source: new OSM(),
  visible: false,
});

var stylesThin = [];
var steps = 3;
var styles = [];

for (var i = 0; i < steps; i++) {
  styles.push(
    new Style({
      stroke: new Stroke({
        color: [51, 255, 255, 1 / (steps - i)],
        width: (steps - i) * 0.5 - 1,
      }),
    })
  );
}

var landFillStyle = new Fill({
  color: [114, 159, 166, 0.8],//0.2
});

var countryBoundaryStyle = new Style({
  fill: landFillStyle,
  stroke: new Stroke({
    // color: "lightblue",
    color:"#55A4CC",
    width: 1,
  }),
});

var countryBoundaryStyleThin = new Style({
  stroke: new Stroke({
       // color: "lightblue",
       color:"#55A4CC",
    width: 1,
  }),
});

styles.push(countryBoundaryStyle);
stylesThin.push(countryBoundaryStyleThin);

var glowStyle = new Style({
  stroke: new Stroke({
    color: "#00FF00",
    width: 4,
    lineCap: "round",
    lineJoin: "round",
  }),
});

var url = require("../data/1country_boundary.geojson");
var cityVillageUrl = require("../data/gadm41_LKA_2.geojson");
var ADMLevel2Url = require("../data/LKA-ADM2.geojson");
var ADMLevel3Url = require("../data/LKA-ADM3.geojson");

var maldivesADM1 = require("../data/MDV-ADM1.geojson");
var maldivesADM2 = require("../data/MDV-ADM2.geojson");

var url = require("../data/1country_boundary.geojson");

var countryBoundarySource = new Vector({
  url: url,
  format: new GeoJSON(),
  loader: function (extent, resolution, projection) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url);
    xhr.onload = function () {
      if (xhr.status === 200) {
        var features = countryBoundarySource
          .getFormat()
          ?.readFeatures(xhr.responseText) as Feature<Geometry>[];
        features?.forEach(function (feature) {
          feature.getGeometry()?.transform("EPSG:4326", "EPSG:3857");
        });
        countryBoundarySource.addFeatures(features);
      } else {
        console.error("Failed to load GeoJSON file: " + url);
      }
    };
    xhr.send();
  },
});

var countryBoundaryAllCityVillageNameSource = new Vector({
  url: cityVillageUrl,
  format: new GeoJSON(),
  loader: function (extent, resolution, projection) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", cityVillageUrl);
    xhr.onload = function () {
      if (xhr.status === 200) {
        var features = countryBoundaryAllCityVillageNameSource
          .getFormat()
          ?.readFeatures(xhr.responseText) as Feature<Geometry>[];
        features?.forEach(function (feature) {
          feature.getGeometry()?.transform("EPSG:4326", "EPSG:3857");
        });
        countryBoundaryAllCityVillageNameSource.addFeatures(features);
      } else {
        console.error("Failed to load GeoJSON file: " + cityVillageUrl);
      }
    };
    xhr.send();
  },
});


var maldivesADM1Source = new Vector({
  url: maldivesADM1,
  format: new GeoJSON(),
  loader: function (extent, resolution, projection) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", maldivesADM1);
    xhr.onload = function () {
      if (xhr.status === 200) {
        var features = maldivesADM1Source
          .getFormat()
          ?.readFeatures(xhr.responseText) as Feature<Geometry>[];
        features?.forEach(function (feature) {
          feature.getGeometry()?.transform("EPSG:4326", "EPSG:3857");
        });
        maldivesADM1Source.addFeatures(features);
      } else {
        console.error("Failed to load GeoJSON file: " + url);
      }
    };
    xhr.send();
  },
});

var maldivesADM2Source = new Vector({
  url: maldivesADM2,
  format: new GeoJSON(),
  loader: function (extent, resolution, projection) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", maldivesADM2);
    xhr.onload = function () {
      if (xhr.status === 200) {
        var features = maldivesADM2Source
          .getFormat()
          ?.readFeatures(xhr.responseText) as Feature<Geometry>[];
        features?.forEach(function (feature) {
          feature.getGeometry()?.transform("EPSG:4326", "EPSG:3857");
        });
        maldivesADM2Source.addFeatures(features);
      } else {
        console.error("Failed to load GeoJSON file: " + maldivesADM2);
      }
    };
    xhr.send();
  },
});

var districtNameSource = new Vector({
  url: ADMLevel2Url,
  format: new GeoJSON(),
  loader: function (extent, resolution, projection) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", ADMLevel2Url);
    xhr.onload = function () {
      if (xhr.status === 200) {
        var features = districtNameSource
          .getFormat()
          ?.readFeatures(xhr.responseText) as Feature<Geometry>[];
        features?.forEach(function (feature) {
          feature.getGeometry()?.transform("EPSG:4326", "EPSG:3857");
        });
        districtNameSource.addFeatures(features);
      } else {
        console.error("Failed to load GeoJSON file: " + cityVillageUrl);
      }
    };
    xhr.send();
  },
});

var divitionNameSource = new Vector({
  url: ADMLevel3Url,
  format: new GeoJSON(),
  loader: function (extent, resolution, projection) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", ADMLevel3Url);
    xhr.onload = function () {
      if (xhr.status === 200) {
        var features = divitionNameSource
          .getFormat()
          ?.readFeatures(xhr.responseText) as Feature<Geometry>[];
        features?.forEach(function (feature) {
          feature.getGeometry()?.transform("EPSG:4326", "EPSG:3857");
        });
        divitionNameSource.addFeatures(features);
      } else {
        console.error("Failed to load GeoJSON file: " + cityVillageUrl);
      }
    };
    xhr.send();
  },
});

var countryBoundaryLayer = new VectorLayer({
  source: countryBoundarySource,
  style: styles,
});

var countryBoundaryLayerThin = new VectorLayer({
  source: countryBoundarySource,
  style: stylesThin,
});

var districtBoundaryLayerThin = new VectorLayer({
  source: districtNameSource,
  style: stylesThin,
});

var divitionBoundaryLayerThin = new VectorLayer({
  source: divitionNameSource,
  style: styles,
  visible: false,
});

const variables = {
  exposure: 0,
  contrast: 0,
  saturation: 0,
};

export const updateMapCenter = (longCoordinate: number, latCoordinate: number, zoom: number) => {
  const view = map.getView();
  const newCenter = fromLonLat([longCoordinate, latCoordinate]);
  view.setCenter(newCenter)
  view.setZoom(zoom)
}

export const updateMapZoom = (zoom: number) => {
  const view = map.getView();
  view.setZoom(zoom)
}


const viewCommon= new View({
  center: fromLonLat([longCoordinate,latCoordinate]),
  zoom:6,
})

export const map = new Map({
  target: "map",
  layers: [
    countryBoundaryLayer,
    countryBoundaryLayerThin,
    districtBoundaryLayerThin,
    divitionBoundaryLayerThin,
    osmLayer,
    pressureLayerGroup,
    weatherLayerGroup,
  ],
  controls: [],
  view:viewCommon
});

export const mapHidden = new Map({
  target: "hidden-map",
  layers: [
    countryBoundaryLayer,
  ],
  controls: [],
  view:viewCommon
});



viewCommon.on("change:resolution", () => {
  const zoom = viewCommon.getZoom();
 
  // console.log("___________", windWmsLayersCurrent);
  
  // if (zoom! >= 9) {
  //   osmLayer.setVisible(true);
  //   countryNameVectorLayer.setVisible(false);
  //   allCityNameVillageNameVectorLayer.setVisible(false);
  //   countryBoundaryLayer.setVisible(false);
  //   allDistrictNameVectorLayer.setVisible(false);
  //   allDivitionNameVectorLayer.setVisible(false);
  //   divitionBoundaryLayerThin.setVisible(false); 
  // }
   if(zoom! >=12) {
    osmLayer.setVisible(true);
    countryNameVectorLayer.setVisible(false);
    allCityNameVillageNameVectorLayer.setVisible(false);
    countryBoundaryLayer.setVisible(false);
    allDistrictNameVectorLayer.setVisible(false);
    allDivitionNameVectorLayer.setVisible(false);
    divitionBoundaryLayerThin.setVisible(false); 

     maldivesAdm1Name.setVisible(false);
     maldivesAdm1Name.setVisible(false);
  }
   else if(zoom! <12 && zoom! >=7) {
    osmLayer.setVisible(false);
    //maldives adm2 names

    maldivesAdm1Name.setVisible(true);
    maldivesAdm1Name.setVisible(true);

    countryNameVectorLayer.setVisible(true);
    allCityNameVillageNameVectorLayer.setVisible(false);

  

    countryBoundaryLayer.setVisible(true);
    allDistrictNameVectorLayer.setVisible(true);
    allDivitionNameVectorLayer.setVisible(false);
    divitionBoundaryLayerThin.setVisible(false); 
  }else if(zoom! <7 && zoom! >=5) {
    osmLayer.setVisible(false);
    countryNameVectorLayer.setVisible(true);
    allCityNameVillageNameVectorLayer.setVisible(false);
    countryBoundaryLayer.setVisible(true);
    allDistrictNameVectorLayer.setVisible(false);
    allDivitionNameVectorLayer.setVisible(false);
    divitionBoundaryLayerThin.setVisible(false); 

    
     maldivesAdm1Name.setVisible(false);
    maldivesAdm1Name.setVisible(false);
  }
});

const countryNameVectorLayer = new VectorLayer({
  source: countryBoundarySource,
  style: (feature) =>
    new Style({
      text: new Text({
        text: feature.get("ADMIN"),
        font: "16px Calibri,sans-serif",
        fill: new Fill({
          color: "#000",
        }),
        stroke: new Stroke({
          color: "#fff",
          width: 3,
        }),
      }),
    }),
});

const maldivesAdm1Name = new VectorLayer({
  source: maldivesADM1Source,
  style: (feature) =>
    new Style({
      text: new Text({
        text: feature.get("shapeName"),
        font: "15px Calibri,sans-serif",
        fill: new Fill({
          color: "white",
        }),
        // stroke: new Stroke({
        //   color: "white",
        //   width: 1,
        // }),
      }),
    }),
});

const maldivesAdm2Name = new VectorLayer({
  source: maldivesADM2Source,
  style: (feature) =>
    new Style({
      text: new Text({
        text: feature.get("shapeName"),
        font: "15px Calibri,sans-serif",
        fill: new Fill({
          color: "white",
        }),
        // stroke: new Stroke({
        //   color: "white",
        //   width: 1,
        // }),
      }),
    }),
});

const allCityNameVillageNameVectorLayer = new VectorLayer({
  source: countryBoundaryAllCityVillageNameSource,
  style: (feature) =>
    new Style({
      
      text: new Text({
        text: feature.get("shapeName"),
        font: "15px Calibri,sans-serif",
        fill: new Fill({
          color: "white",
        }),
        // stroke: new Stroke({
        //   color: "white",
        //   width: 1,
        // }),
      }),
      // text: new Text({
      //   text: feature.get("NAME_2"),
      //   font: "12px Calibri,sans-serif",
      //   fill: new Fill({
      //     color: "#FFF",
      //   }),
      //   stroke: new Stroke({
      //     color: "#000",
      //     width: 1,
      //   }),
      // }),
    }),
});

const allDistrictNameVectorLayer = new VectorLayer({
  source: districtNameSource,
  style: (feature) =>
    new Style({
      
      text: new Text({
        text: feature.get("shapeName"),
        font: "15px Calibri,sans-serif",
        fill: new Fill({
          color: "white",
        }),
        // stroke: new Stroke({
        //   color: "white",
        //   width: 1,
        // }),
      }),
      // text: new Text({
      //   text: feature.get("shapeName"),
      //   font: "12px Calibri,sans-serif",
      //   fill: new Fill({
      //     color: "black",
      //   }),
      //   stroke: new Stroke({
      //     color: "white",
      //     width: 1,
      //   }),
      // }),
    }),
});

const allDivitionNameVectorLayer = new VectorLayer({
  source: divitionNameSource,
  style: (feature) =>
    new Style({
      
      text: new Text({
        text: feature.get("shapeName"),
        font: "15px Calibri,sans-serif",
        fill: new Fill({
          color: "white",
        }),
        // stroke: new Stroke({
        //   color: "white",
        //   width: 1,
        // }),
      }),
      // text: new Text({
      //   text: feature.get("shapeName"),
      //   font: "12px Calibri,sans-serif",
      //   fill: new Fill({
      //     color: "black",
      //   }),
      //   stroke: new Stroke({
      //     color: "white",
      //     width: 1,
      //   }),
      // }),
    }),
});

map.addLayer(countryNameVectorLayer);
map.addLayer(allCityNameVillageNameVectorLayer);
map.addLayer(allDistrictNameVectorLayer);
map.addLayer(allDivitionNameVectorLayer);

map.addLayer(maldivesAdm2Name);
map.addLayer(maldivesAdm1Name);

